import { apiRequest } from '@/lib/api-client';
import {
  assertAnalyticsResponseScope,
  normalizeAnalyticsAddress
} from '@/lib/investor-analytics';
import {
  investorFeesQuerySchema,
  investorFeesResponseSchema,
  type InvestorFeesQuery,
  type InvestorFeesResponse
} from '../types/api';

export async function fetchInvestorFees(
  address: string,
  chainId: number,
  params: InvestorFeesQuery = {},
  signal?: AbortSignal
): Promise<InvestorFeesResponse> {
  const investor = normalizeAnalyticsAddress(address);
  const query = investorFeesQuerySchema.parse(params);
  const response = await apiRequest(
    `/api/v1/investor/${encodeURIComponent(investor)}/fees`,
    investorFeesResponseSchema,
    {
      auth: 'required',
      chainId,
      query,
      signal
    }
  );

  assertAnalyticsResponseScope(investor, chainId, response);
  return response;
}
